import React from "react";

const Footer = () => {
  return (
    <footer className="footer py-4  ">
      <div className="container-fluid">
        <div className="row align-items-center justify-content-lg-between">
          <div className="col-lg-6 mb-lg-0 mb-4">
            <div className="copyright text-center text-sm text-muted text-lg-start">
              © {new Date().getFullYear()}{" "}
              <a
                href="https://getfluidapps.com/"
                className="text-muted"
                target="_blank"
                rel="noreferrer"
              >
                fluidapps.com
              </a>
            </div>
          </div>
          <div className="col-lg-6">
            <ul className="nav nav-footer justify-content-center justify-content-lg-end">
              <li className="nav-item">
                <a
                  href="https://getfluidapps.com/"
                  className="nav-link text-muted"
                  target="_blank"
                  rel="noreferrer"
                >
                  Fluid apps
                </a>
              </li>
              <li className="nav-item">
                <a
                  href="https://getfluidapps.com/"
                  className="nav-link text-muted"
                  target="_blank"
                  rel="noreferrer"
                >
                  About Us
                </a>
              </li>
              <li className="nav-item">
                <a
                  href="https://getfluidapps.com/"
                  className="nav-link text-muted"
                  target="_blank"
                  rel="noreferrer"
                >
                  Blog
                </a>
              </li>
              <li className="nav-item">
                <a
                  href="https://getfluidapps.com/"
                  className="nav-link pe-0 text-muted"
                  target="_blank"
                  rel="noreferrer"
                >
                  License
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
